import {
  SET_ROUTE_PAGINATION,
  SET_MULTI_TOUR_VIEW,
  SET_DELETED_ROUTE,
  SET_REASSIGNED_SHIPMENTS,
  EDIT_ROUTE,
  SET_LOCKED_VEHICLES,
  SET_MUST_MODE_SHIPMENTS,
  SET_ROUTE_RANGE_DATA,
  SET_ROUTES_BY_PROCESS,
  SET_TIMELINE_HIGHLIGHTS,
  SET_TIMELINE_RANGE,
  SET_IS_MUST_MODE_ENABLED,
  SET_IS_UPDATE_PLANNING_RUNNING,
  RESET_REASSIGNED_SHIPMENTS,
  SET_FOCUSED_ROUTE,
  SET_CACHE,
  SET_PROCESS_BY_DATE,
  ADD_ROUTES,
  UPDATE_ROUTES,
  SET_ROUTE_STRINGS,
  SET_SINGLE_TOUR_VIEW,
  UPDATE_ROUTE_CACHE
} from '../types';
import { Pagination, Route, Delivery, DayDataType, RouteCache, TimelineHighlight, TLRange } from '@/config/types/Routes';

export function setPagination(pagination: Pagination<Route>) {
  return {
    type: SET_ROUTE_PAGINATION,
    data: pagination
  };
}

export function setAggregatedTourView(ids: number[]) {
  return {
    type: SET_MULTI_TOUR_VIEW,
    data: ids
  };
}

export function setDeletedRoutes(routes: { [planningId: string]: number }) {
  return {
    type: SET_DELETED_ROUTE,
    data: routes
  };
}

export function setReassignedShipments(vehicleId: number, shipment: Delivery) {
  return {
    type: SET_REASSIGNED_SHIPMENTS,
    data: { vehicleId, shipment }
  };
}

export function routeUpdate(route: Route) {
  return {
    type: EDIT_ROUTE,
    data: route
  };
}

export function setLockedVehicles(vehicles: number[]) {
  return {
    type: SET_LOCKED_VEHICLES,
    data: vehicles
  };
}

export function setMustModeShipments(shipmentIds: number[]) {
  return {
    type: SET_MUST_MODE_SHIPMENTS,
    data: shipmentIds
  };
}

export function setDayData(props: Partial<DayDataType>) {
  return {
    type: SET_ROUTE_RANGE_DATA,
    data: props
  };
}

export function setProcess(id: string) {
  return {
    type: SET_ROUTES_BY_PROCESS,
    data: id
  };
}

export function setTimelineHighlights(query: TimelineHighlight[]) {
  return {
    type: SET_TIMELINE_HIGHLIGHTS,
    data: query
  };
}

export function setTimelineRange(range: TLRange) {
  return {
    type: SET_TIMELINE_RANGE,
    data: range
  };
}

export function setIsMustModeEnabled(isEnabled: boolean) {
  return {
    type: SET_IS_MUST_MODE_ENABLED,
    data: isEnabled
  };
}

export function setIsUpdatePlanningRunning(isRunning: boolean) {
  return {
    type: SET_IS_UPDATE_PLANNING_RUNNING,
    data: isRunning
  };
}

export function resetReassignedShipments() {
  return {
    type: RESET_REASSIGNED_SHIPMENTS,
  };
}

export function focusRoute(route: Route, color: string, deliveries: Delivery[]) {
  return {
    type: SET_FOCUSED_ROUTE,
    data: {
      route,
      color,
      deliveries
    }
  };
}

export function setCache(data: RouteCache) {
  return {
    type: SET_CACHE,
    data
  };
}

export function setRoutes(routes: Route[], update: boolean = false) {
  return {
    type: ADD_ROUTES,
    data: { routes, update }
  };
}

export function setRouteStrings(strings: { [key: string]: string }) {
  return {
    type: SET_ROUTE_STRINGS,
    data: strings
  };
}

export function reloadRoutes (reload: boolean) {
  return {
    type: UPDATE_ROUTES,
    data: reload
  };
}

export function setSingleTourView(route: Route, color: string, routestring: string) {
  return {
    type: SET_SINGLE_TOUR_VIEW,
    data: { route, color, routestring }
  };
}

export function updateCache(cache: RouteCache) {
  return {
    type: UPDATE_ROUTE_CACHE,
    data: cache
  };
}